export default __webpack_public_path__ + "static/media/00.2af8ee61.jpg";